import {
  AutopilotTaskDto,
  TaskBlockerBlockerType,
} from '@urbanx/agx.activities.client'
import { AgxEmptyState, AgxSpacer } from '@urbanx/agx.ui-components2'
import { JSX, ReactNode } from 'react'
import { LaunchApprovalBlocker } from './LaunchApprovalBlocker'
import { NoLaunchDateBlocker } from './NoLaunchDateBlocker'

interface LaunchTaskBlockerProps {
  task: AutopilotTaskDto
  children: ReactNode
  onTasksInvalidated?: () => void | Promise<void>
}

export const LaunchTaskBlocker = ({
  task,
  children,
  onTasksInvalidated,
}: LaunchTaskBlockerProps): JSX.Element => {
  const campaignId = task.campaignId
  const blockerTypes = new Set((task.blockers ?? []).map((b) => b.blockerType))
  const isUnassigned = !task.assignedTo || task.assignedTo === 'Unassigned'

  if (blockerTypes.has(TaskBlockerBlockerType.LaunchDateNotSet)) {
    return <NoLaunchDateBlocker task={task} />
  }

  if (isUnassigned) {
    return (
      <AgxSpacer
        direction="horizontal"
        fill
        contentAlignment="center"
        contentJustification="center"
      >
        <AgxEmptyState
          variant="advanced"
          glyphType="locked"
          actionButtons={[]}
          label="Assign task to unlock"
        />
      </AgxSpacer>
    )
  }

  if (
    blockerTypes.has(TaskBlockerBlockerType.ApprovalReceivedNotConfirmed) &&
    campaignId
  ) {
    return (
      <LaunchApprovalBlocker
        campaignId={campaignId}
        onTasksInvalidated={onTasksInvalidated}
      />
    )
  }

  return <>{children}</>
}
